import { render } from "./ProductPreviewComponent.vue?vue&type=template&id=5381d50e"
import script from "./ProductPreviewComponent.vue?vue&type=script&lang=js"
export * from "./ProductPreviewComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__